import React from 'react';
import PropTypes from 'prop-types';
import { Container, Alert, Button, Typography } from '@mui/material';
import PageHeader from '../../components/PageHeader';

class EmailActionErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null, 
            errorInfo: null 
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to monitoring service in production
        console.error('Email Action Error:', error, errorInfo);
        
        this.setState({
            error,
            errorInfo,
        });

        // TODO: Send to error tracking service (e.g., Sentry, LogRocket)
        // errorTrackingService.captureException(error, {
        //     tags: { component: 'EmailAction' },
        //     extra: errorInfo
        // });
    }

    handleRetry = () => {
        // Reset error boundary state
        this.setState({ 
            hasError: false, 
            error: null, 
            errorInfo: null 
        });
    };

    handleGoToLogin = () => {
        window.location.href = '/auth/login';
    };

    render() {
        const styles = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '80vh',
        };

        if (this.state.hasError) {
            return (
                <Container sx={styles} maxWidth='md'>
                    <PageHeader text='Something went wrong' variant='h4' />
                    
                    <Alert severity="error" sx={{ mt: 2, width: '100%', maxWidth: 400 }}>
                        An unexpected error occurred while processing your email action. 
                        Please try again or contact support if the problem persists.
                    </Alert>

                    {process.env.NODE_ENV === 'development' && (
                        <details style={{ 
                            marginTop: '20px', 
                            whiteSpace: 'pre-wrap',
                            maxWidth: '600px',
                            fontSize: '12px'
                        }}>
                            <summary>Error Details (Development Only)</summary>
                            {this.state.error && this.state.error.toString()}
                            <br />
                            {this.state.errorInfo.componentStack}
                        </details>
                    )}

                    <div style={{ 
                        display: 'flex', 
                        gap: '16px', 
                        marginTop: '24px' 
                    }}>
                        <Button 
                            variant="outlined" 
                            onClick={this.handleRetry}
                        >
                            Try Again
                        </Button>
                        <Button 
                            variant="contained" 
                            onClick={this.handleGoToLogin}
                        >
                            Go to Login
                        </Button>
                    </div>
                </Container>
            );
        }

        return this.props.children;
    }
}

EmailActionErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};

export default EmailActionErrorBoundary;
